module.exports = __webpack_public_path__ + "img/default.af841126.png";